import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FormField } from 'Src/feature/form/FormField';
import { normalizer } from 'Src/feature/form/FormFieldCurrencyInput';
import { Modal } from 'Src/feature/modal/Modal';
import { ModalAction } from 'Src/feature/modal/ModalAction';
import { ModalActions } from 'Src/feature/modal/ModalActions';
import { ModalContent } from 'Src/feature/modal/ModalContent';
import { ModalHeader } from 'Src/feature/modal/ModalHeader';
import { ModalTitle } from 'Src/feature/modal/ModalTitle';

interface FlipAndTipCustomTipModalProps {
    isOpen: boolean;
    onClose: () => void;
    onDone: (value: string | undefined) => void;
}

const FlipAndTipCustomTipModal = ({ isOpen, onClose, onDone }: FlipAndTipCustomTipModalProps) => {
  const { t } = useTranslation();
  const [customTipInputValue, setCustomTipInputValue] = useState<string | undefined>();

  const handleCustomTipInputChange = (value: string) => {
    const normalizedValue = normalizer(value);
    setCustomTipInputValue(normalizedValue);
  };

  return (
    <Modal open={isOpen} variant="grow">
      <ModalHeader>
        <ModalTitle copy={t('flipAndTip.labels.customTipAmount')} />
      </ModalHeader>
      <ModalContent flex={{ alignItems: 'center', justifyContent: 'center' }}>
        <FormField type="currencyInput"
          onChange={handleCustomTipInputChange}
          value={customTipInputValue} />
      </ModalContent>
      <ModalActions>
        <ModalAction
          color="secondary"
          onClick={onClose}
          label={t('labels.cancel')}
        />
        <ModalAction
          color="primary"
          onClick={() => {
            onDone(customTipInputValue);
            onClose();
          }}
          label={t('labels.done')}
        />
      </ModalActions>
    </Modal>
  );
};

export { FlipAndTipCustomTipModal };
